import React, { useState } from 'react';
import { Edit, Delete } from 'jbc-front/components/icons';
import classNames from 'classnames';
import { concatParamsToUrl, redirectTo, serializeHttpGetParams } from 'src/utils/Http';
import { COMPANY_SHOW } from 'src/constants/EndpointUrls';
import styles from '../CompanyList.scss';
import { useTranslation } from 'react-i18next';
import DeleteCompanyConfirmModal from './DeleteCompanyConfirmModal';

const CompanyDetail = props => {
  const { t } = useTranslation();
  const { company } = props;
  const editUrl = concatParamsToUrl(COMPANY_SHOW, { id: company.id });
  const [isOpen, setIsOpen] = useState(false);
  return (
    <React.Fragment>
      <tr key={company.id}>
        <td>{company.corporateNumber}</td>
        <td>{company.officeName}</td>
        <td>{company.telNumber}</td>
        <td>
          <span className={styles.icon}>
            <Edit onClick={() => redirectTo(editUrl)} size={18} />
          </span>
          {company.hasEmployeeClientBranches || company.isEmployeePaysConfirmed ?
            <span className={styles.nodelete}>
              <Delete onClick={e => e.preventDefault()} size={18} />
              <span className={styles.nodeleteText}>{t('features.Clients.components.CompanyDetail.cannot_delete')}</span>
            </span>
            :
            <span className={styles.icon}>
              <Delete  onClick={() => setIsOpen(true)} size={18} />
            </span>
          }
        </td>
      </tr>
      <DeleteCompanyConfirmModal
        hideModal={() => setIsOpen(false)}
        isOpen={isOpen}
        company={company}
      />
    </React.Fragment>
  );
};

export default CompanyDetail;